import React from 'react'
import CIcon from '@coreui/icons-react'
import { CNavItem } from '@coreui/react-pro'
import Dashboard from '@mui/icons-material/Dashboard'
import EventNote from '@mui/icons-material/EventNote'
import LocalHospital from '@mui/icons-material/LocalHospital'
import People from '@mui/icons-material/People'
import PersonalVideo from '@mui/icons-material/PersonalVideo'
import Settings from '@mui/icons-material/Settings'
import TaskAlt from '@mui/icons-material/TaskAlt'
import AccountBalanceWallet from '@mui/icons-material/AccountBalanceWallet'
import { StyledNavLink } from './components/styledComponents'

const _nav = [
  {
    component: StyledNavLink,
    name: 'Dashboard',
    to: '/workplace/',
    icon: <Dashboard />,
  },
  {
    component: StyledNavLink,
    name: 'Wellness Goals',
    to: '/workplace/organization-goals',
    icon: <TaskAlt />,
  },

  {
    component: StyledNavLink,
    name: 'Members',
    to: '/workplace/members',
    icon: <People />,
  },
  {
    component: StyledNavLink,
    name: 'One on One',
    to: '/workplace/one-on-one',
    icon: <LocalHospital />,
  },
  {
    component: StyledNavLink,
    name: 'Webinars',
    to: '/workplace/webinars',
    icon: <PersonalVideo />,
  },
  {
    component: StyledNavLink,
    name: 'Bookings',
    to: '/workplace/bookings',
    icon: <EventNote />,
  },
  {
    component: StyledNavLink,
    name: 'Wallet & Credits',
    to: '/workplace/wallet',
    icon: <AccountBalanceWallet />,
  },
  {
    component: StyledNavLink,
    name: 'Settings',
    to: '/workplace/profile',
    icon: <Settings />,
  },
]

export default _nav
